import { useState } from 'react';

const items = [
  {
    q: 'Faut-il créer un compte pour utiliser MEDICACLIC ?',
    a: 'Non. La recherche et la consultation de l\'annuaire sont totalement libres. Un compte minimal (nom, prénom, téléphone) est créé uniquement au moment de confirmer un rendez-vous, pour vous permettre de le retrouver, l\'annuler ou le reprogrammer.',
  },
  {
    q: 'Comment fonctionne la prise de rendez-vous en temps réel ?',
    a: 'Chaque praticien connecte son agenda réel (Google Calendar ou Outlook) via OAuth2. Quand vous consultez une fiche, les créneaux affichés sont ceux de son agenda en direct — jamais des créneaux mis en cache. La confirmation est immédiate.',
  },
  {
    q: 'Que se passe-t-il si aucun créneau n\'est disponible ?',
    a: 'La plateforme élargit automatiquement la recherche aux 50 praticiens suivants les plus proches. Si vous préférez attendre votre praticien de premier choix, vous pouvez rejoindre une liste d\'attente : vous serez notifié dès qu\'une annulation libère un créneau.',
  },
  {
    q: 'À quoi sert le code partenaire ?',
    a: 'Si vous êtes rattaché à une entreprise ou un réseau ayant signé un partenariat avec MEDICACLIC, un code partenaire vous est communiqué. En le saisissant lors de la recherche, vous êtes orienté vers les praticiens de votre réseau partenaire — et vous bénéficiez d\'un avantage dédié dans les pharmacies partenaires, sur présentation d\'un QR code unique en caisse.',
  },
  {
    q: 'Puis-je annuler ou déplacer mon rendez-vous ?',
    a: 'Oui, librement, sans pénalité ni frais. L\'annulation est répercutée immédiatement sur l\'agenda du praticien via votre compte MEDICACLIC.',
  },
  {
    q: 'Comment suis-je notifié ?',
    a: 'Les confirmations et rappels sont envoyés par WhatsApp (canal principal). Si WhatsApp n\'est pas disponible, un SMS de secours prend le relais automatiquement.',
  },
  {
    q: 'Mes données personnelles sont-elles protégées ?',
    a: 'Oui. MEDICACLIC est conforme à la Loi 09-08 relative à la protection des données personnelles au Maroc. Aucune donnée n\'est cédée ou revendue, aucune publicité tierce n\'est diffusée.',
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-8 lg:px-12 max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-3">
            Questions fréquentes
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
            Tout ce que vous vous demandez, <span className="italic text-primary-600">clarifié.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((it, idx) => (
            <div
              key={idx}
              className={`rounded-xl border transition-colors ${
                open === idx ? 'bg-primary-50/60 border-primary-300' : 'bg-background-100 border-background-200 hover:border-background-300'
              }`}
            >
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  <a href={`#faq-${idx}`} className="cursor-pointer" onClick={(e) => e.preventDefault()}>{it.q}</a>
                </h4>
                <span className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full transition-transform ${
                  open === idx ? 'bg-primary-500 rotate-45' : 'bg-background-50 border border-background-300'
                }`}>
                  <i className={`ri-add-line text-lg w-5 h-5 flex items-center justify-center ${
                    open === idx ? 'text-background-50' : 'text-foreground-700'
                  }`} />
                </span>
              </button>
              {open === idx && (
                <div className="px-6 pb-5 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {it.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}